import React from 'react'
import Auth from '../components/Auth'

function SignIn() {
    return (
        <div className="container">
            <div className="row justify-content-center authentication authentication-basic align-items-center h-100">
                <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12">
                    <div className="mb-3 d-flex justify-content-center auth-logo">
                        <a href="index-2.html">
                            <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="desktop-dark" />
                        </a>
                    </div>
                    <Auth />
                </div>
            </div>
        </div>

    )
}

export default SignIn